module.exports = __webpack_public_path__ + "img/1113.585ac231.gif";